import { i18n } from '@/utils/i18n';

export const columns = {
    id: {
        show: true,
        title: "№",
        sortable: true,
        column: 'id'
    },
    name: {
        show: true,
        title: i18n.t('message.name'),
        sortable: true,
        column: 'name'
    },
    code: {
        show: true,
        title: i18n.t('message.code'),
        sortable: true,
        column: 'code'
    },
    life_time: {
        show: true,
        title: i18n.t('message.life_time'),
        sortable: true,
        column: 'life_time'
    },
    form_template_id: {
        show: true,
        title: i18n.t('message.conclusion_templates'),
        sortable: true,
        column: 'form_template_id'
    },
    price: {
        show: true,
        title: i18n.t('message.current_price'),
        sortable: true,
        column: 'price'
    },
    resident_price: {
        show: true,
        title: i18n.t('message.resident_price'),
        sortable: true,
        column: 'resident_price'
    },
    color: {
        show: true,
        title: i18n.t('message.color'),
        sortable: true,
        column: 'color'
    },
    secondary_price: {
        show: true,
        title: i18n.t('message.secondary_price'),
        sortable: true,
        column: 'secondary_price'
    },
    secondary_resident_price: {
        show: true,
        title: i18n.t('message.secondary_resident_price'),
        sortable: true,
        column: 'secondary_price'
    },
    service_category: {
        show: true,
        title: i18n.t('message.service_type'),
        sortable: false,
        column: 'service_type'
    },
    is_service: {
        show: false,
        title: i18n.t('message.category_or_service'),
        sortable: true,
        column: 'is_service'
    },
    parent_id: {
        show: true,
        title: i18n.t('message.parent_service'),
        sortable: true,
        column: 'parent_id'
    },
    status: {
        show: true,
        title: i18n.t('message.status'),
        sortable: true,
        column: 'status'
    },
    created_at: {
        show: true,
        title: i18n.t('message.date'),
        sortable: true,
        column: 'created_at'
    },
    updated_at: {
        show: false,
        title: i18n.t('message.update_date'),
        sortable: true,
        column: 'updated_at'
    },
    settings: {
        show: true,
        title: i18n.t('message.settings'),
        sortable: false,
        column: 'settings'
    }
};
